module.exports = __webpack_public_path__ + "img/logo.a68d539a.png";